/* CHICKEN DOG by LINTEL storefront (layout ckd): cart drawer (sections=ckd-cart-drawer), menu, qty, gallery. window.CKD.openCart() for the PDP. */
(function () {
  var drawer = document.getElementById('ckd-drawer');
  var inner = document.getElementById('ckd-cart-inner');
  var menu = document.getElementById('ckd-menu');

  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  function refresh() {
    return fetch('/?sections=ckd-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['ckd-cart-drawer'] || '';
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var sec = tmp.firstElementChild;
        inner.innerHTML = sec ? sec.innerHTML : html;
        var body = inner.querySelector('[data-ckd-n]');
        var n = body ? body.getAttribute('data-ckd-n') : '0';
        document.querySelectorAll('[data-ckd-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-n', n); });
      });
  }
  window.CKD = { openCart: function () { return refresh().then(openDrawer); }, refresh: refresh };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ckd-open],[data-ckd-close],[data-ckd-menu],[data-ckd-qty]');
    if (!t) return;
    if (t.hasAttribute('data-ckd-open')) { e.preventDefault(); refresh().then(openDrawer); }
    else if (t.hasAttribute('data-ckd-close')) { closeDrawer(); }
    else if (t.hasAttribute('data-ckd-menu')) { menu.classList.toggle('is-open'); menu.setAttribute('aria-hidden', menu.classList.contains('is-open') ? 'false' : 'true'); }
    else if (t.hasAttribute('data-ckd-qty')) {
      t.disabled = true;
      fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: t.getAttribute('data-ckd-qty'), quantity: parseInt(t.getAttribute('data-q'), 10) }) })
        .then(refresh);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  if (menu) menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { menu.classList.remove('is-open'); }); });

  /* gallery (same behaviour as the LINTEL component it styles) */
  var gal = document.querySelector('[data-oak-gal]');
  if (gal) {
    var imgs = Array.prototype.slice.call(gal.querySelectorAll('.oak-gal__main img'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.oak-gal__thumbs button'));
    var dotsBox = gal.querySelector('.oak-gal__dots');
    var vis = [], cur = 0;
    var show = function (i) {
      if (!vis.length) return;
      cur = (i + vis.length) % vis.length;
      imgs.forEach(function (el, k) { el.classList.toggle('is-on', k === vis[cur]); });
      thumbs.forEach(function (el, k) { el.classList.toggle('is-on', k === vis[cur]); });
      dotsBox.querySelectorAll('span').forEach(function (d, k) { d.classList.toggle('is-on', k === cur); });
    };
    vis = imgs.map(function (_, k) { return k; });
    dotsBox.innerHTML = vis.map(function () { return '<span></span>'; }).join('');
    dotsBox.querySelectorAll('span').forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { var i = vis.indexOf(k); if (i > -1) show(i); }); });
    gal.querySelectorAll('[data-dir]').forEach(function (b) { b.addEventListener('click', function () { show(cur + parseInt(b.dataset.dir, 10)); }); });
    var main = gal.querySelector('.oak-gal__main'), x0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); x0 = null;
    });
    show(0);
  }
})();
